'use client';

import { useCommandPalette } from '@/src/components/command-palette/use-command-palette';

export function CommandPaletteTrigger() {
  const { open } = useCommandPalette();
  return (
    <button
      type="button"
      onClick={open}
      aria-label="Befehlspalette öffnen"
      data-tour="command-palette-trigger"
      className="inline-flex items-center gap-2 rounded-[var(--k-radius-md)] border border-[var(--k-color-border-default)] bg-[var(--k-color-surface)] px-3 py-1.5 text-xs font-medium text-[var(--k-color-text-secondary)] transition hover:border-[var(--k-color-border-strong)]"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <circle cx="11" cy="11" r="7" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
      Suchen…
      <kbd className="rounded bg-[var(--k-color-surface-muted)] px-1 font-mono text-[10px]">
        ⌘K
      </kbd>
    </button>
  );
}
